import { ModalidadeComercial } from './modalidade-comercial';
import { Faturamento } from './faturamento';

/** Dados dos KPIs de faturamento das modalidades comerciais */
export class ModalidadeComercialFaturamento {
    modalidadesComerciais: ModalidadeComercial[];
    faturamento: Faturamento;

    constructor(props: Partial<ModalidadeComercialFaturamento>) {
        Object.assign(this, props);

        if (props) {
            // Modalidades Comerciais
            this.constructorModalidadesComerciais(props.modalidadesComerciais);
            // Faturamento
            this.faturamento = props.faturamento ? new Faturamento(props.faturamento) : null;
        }
    }

    /** Constructor para as modalidades comerciais */
    private constructorModalidadesComerciais(modalidadesComerciais: ModalidadeComercial[]) {
        if (modalidadesComerciais && Array.isArray(modalidadesComerciais)) {
            this.modalidadesComerciais = modalidadesComerciais.map(modalidadeComercial => new ModalidadeComercial(modalidadeComercial));
        } else {
            this.modalidadesComerciais = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ModalidadeComercialFaturamento {
        return new ModalidadeComercialFaturamento(JSON.parse(json));
    }
}
